import type { OrderSource } from "./order-source";
import { ORDER_SOURCE_IDS } from "@/pages/Orders/orders.types";
import { PERMISSIONS } from "@/config";
import { toOrder } from "@/services/orders/lcr-order.mapper";
import { LcrOrdersService } from "@/services/orders/lcr-orders-service";

let lcrOrdersService: LcrOrdersService | undefined;
const getLcrOrdersService = (): LcrOrdersService => (lcrOrdersService ??= new LcrOrdersService());

export const lcrOrderSource: OrderSource = {
  id: ORDER_SOURCE_IDS.lcr,
  isEnabled: (context) => context.hasPermission(PERMISSIONS.USE_LCR),
  fetch: async () => (await getLcrOrdersService().getMyLcrOrders()).map(toOrder),
};
